import React, { useState, useEffect } from "react";
import "../../css/PriorityPopup.css";
import { useToast } from "../../Contexts/ToastContext";
import ConfirmWithPhrasePopup from "../Common/ConfirmWithPhrasePopup";
import useApi from "../CustomHooks/useApi";
import { tripAPI } from "../../api/apiClient";
import { FaSpinner, FaSyncAlt, FaClipboard } from "react-icons/fa";
import { useTripContext } from "./TripContext";

const PriorityPopup = ({ onClose, tripGuid }) => {
  const { showToast, clearToast } = useToast();
  const { callApi, isLoading } = useApi();
  const { tripData } = useTripContext();

  const [priorityLink, setPriorityLink] = useState(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  const baseUrl = process.env.REACT_APP_PRIORITY_LINK_BASE || "https://twoja-aplikacja.pl";

  const fetchPriorityKey = async () => {
    await callApi(
      () => tripAPI.getPriorityKey(tripGuid),
      async (res) => {
        setPriorityLink(`${baseUrl}/r/${res}`);
      },
      () => showToast("Nie udało się pobrać klucza.", "error")
    );
  };

  const refreshPriorityKey = async () => {
    setShowConfirmPopup(false);
    await callApi(
      () => tripAPI.refreshPriorityKey(tripGuid),
      async (res) => {
        setPriorityLink(`${baseUrl}/r/${res}`);
        showToast("Nowy link został wygenerowany.", "success");
      },
      () => clearToast()
    );
  };

  const handleCopy = () => {
    if (!priorityLink) return;
    navigator.clipboard.writeText(priorityLink);
    showToast("Skopiowano link do schowka!", "info");
  };

  useEffect(() => {
    fetchPriorityKey();
  }, []);

  const formattedVariants = (tripData?.variants || []).map(v => {
    const date = new Date(v.registrationStartDate);
    date.setDate(date.getDate() - 1);
    return {
      name: v.name,
      formattedDate: date.toLocaleDateString("pl-PL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      })
    };
  });

  return (
    <div className="priority-popup">
      <div className="priority-popup-content">
        <div className="priority-popup-close" onClick={onClose}>×</div>
        <h2>Zapisy priorytetowe</h2>

        <p><strong>Link do zapisów:</strong></p>
        <p className="priority-link">
          {isLoading || !priorityLink ? (
            <FaSpinner className="priority-fa-spinner" />
          ) : (
            priorityLink
          )}
        </p>

        <div className="priority-actions-row">
          <div className="priority-icon priority-icon-copy" onClick={handleCopy} title="Skopiuj link">
            <FaClipboard />
          </div>
          <div className="priority-icon priority-icon-refresh" onClick={() => setShowConfirmPopup(true)} title="Odśwież link">
            <FaSyncAlt />
          </div>
        </div>

        <h3>Zapisy priorytetowe:</h3>
        <ul className="priority-variant-list">
          {formattedVariants.map((v, i) => (
            <li key={i} className="priority-variant-line">
              <span className="priority-variant-name">{v.name}</span>
              {" – "}
              <span className="priority-variant-date"><strong>{v.formattedDate}</strong></span>
            </li>
          ))}
        </ul>

        {showConfirmPopup && (
          <ConfirmWithPhrasePopup
            text="Czy na pewno chcesz odświeżyć link do zapisów priorytetowych? Obecny link przestanie działać."
            phrase="okoń"
            onConfirm={refreshPriorityKey}
            onCancel={() => setShowConfirmPopup(false)}
          />
        )}
      </div>
    </div>
  );
};

export default PriorityPopup;
